module.exports = __webpack_public_path__ + "img/menu3.5f8172ed.png";